import { TakeAwardClickBuilder } from '../../builders'
import { BaseController } from '../base.controller/base.controller'

export class RewardsAnalytics extends BaseController {
  /**
   * Клик по кнопке "Забрать награду" в reward
   */
  onTakeAwardClick(frequency) {
    this.send(TakeAwardClickBuilder, { frequency })
  }
}
